import { Component, OnInit  } from '@angular/core';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { DatePipe } from "@angular/common";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
// tslint:disable-next-line:no-duplicate-imports
import { FormControl } from '@angular/forms';
import { DocumentoNegociableService } from 'app/services/documento-negociable/documento-negociable.service';
import { FiltrosDocumentosNegociables } from 'app/models/FiltrosDocumentosNegociables';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';



export const MY_FORMATS = {
    parse: {
      dateInput: 'MM/YYYY',
    },
    display: {
      dateInput: 'MMM/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };
  @Component({
    selector: 'app-dashboardTableros',
    templateUrl: './dashboardTableros.component.html',
    styleUrls: ['./dashboardTableros.component.scss'],
    providers:[DatePipe,
      {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
  
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
  })

  export class DashboardTablerosComponent implements OnInit{
    loading:boolean;
    DTOFiltrosDocNeg :FiltrosDocumentosNegociables = new FiltrosDocumentosNegociables();
    docNegociablesReg:any ;
    docNegociablesVer:any = [];
    docNegociablesCot:any =[];
    docNegociablesCon:any =[];
    docNegociablesDes:any =[];
    docNegociablesPag:any =[];
    docNegociablesLiq:any =[];
    docNegociablesSub:any =[];
    docNegociablesBaj:any =[];
    cards;
    filteredAdq: Observable<any[]>;
    Adq = new FormControl('');
    razonSocialFilter = new FormControl('');
    proveedoresArr;
    docArray :any;
    miniloading:boolean;
  
    constructor( private negociablesService:DocumentoNegociableService, private dashboardService:DashboardService){
      
    }


    
    ngOnInit(){

      this.ObtenerDnRegistrado();
      
    }

 
    applyFilter(value: string) {
      const filterValue = value.toString().toUpperCase();
      return this.docNegociablesReg.filter(
        state => state.RazonSocialAdquirente.toUpperCase().indexOf(filterValue) !== -1
      );
    }

     

     filterItems1 (query : string)  {
      
      const filterItems = query1 => {
        return this.docNegociablesReg.filter((el) =>
          el.RazonSocialProveedor.toUpperCase().indexOf(query1.toUpperCase()) > -1
          || el.RazonSocialAdquirente.toUpperCase().indexOf(query1.toUpperCase()) > -1
        );
      }
      this.docNegociablesReg = filterItems(query);
    }

    filterItems2 (query : string)  {
      
      const filterItems = query2 => {
        return this.docNegociablesVer.filter((el) =>
          el.RazonSocialProveedor.toUpperCase().indexOf(query2.toUpperCase()) > -1
          || el.RazonSocialAdquirente.toUpperCase().indexOf(query2.toUpperCase()) > -1
        );
      }
      this.docNegociablesVer = filterItems(query);
    }
    
    filterItems3 (query : string)  {
      
      const filterItems = query3 => {
        return this.docNegociablesCot.filter((el) =>
          el.RazonSocialProveedor.toUpperCase().indexOf(query3.toUpperCase()) > -1
          || el.RazonSocialAdquirente.toUpperCase().indexOf(query3.toUpperCase()) > -1
        );
      }
      this.docNegociablesCot = filterItems(query);
    }

    filterItems4 (query : string)  {
      
      const filterItems = query4 => {
        return this.docNegociablesCon.filter((el) =>
          el.RazonSocialProveedor.toUpperCase().indexOf(query4.toUpperCase()) > -1
          || el.RazonSocialAdquirente.toUpperCase().indexOf(query4.toUpperCase()) > -1
        );
      }
      this.docNegociablesCon = filterItems(query);
    }

    filterItems5 (query : string)  {
      
      const filterItems = query5 => {
        return this.docNegociablesBaj.filter((el) =>
          el.RazonSocialProveedor.toUpperCase().indexOf(query5.toUpperCase()) > -1
          || el.RazonSocialAdquirente.toUpperCase().indexOf(query5.toUpperCase()) > -1
        );
      }
      this.docNegociablesBaj = filterItems(query);
    }

    limpiar(){
      this.docNegociablesReg = JSON.parse(sessionStorage.getItem('lstDnAdqReg'))
      this.docNegociablesVer = JSON.parse(sessionStorage.getItem('lstDnAdqVer'))
      this.docNegociablesCot = JSON.parse(sessionStorage.getItem('lstDnAdqCot'))
      this.docNegociablesCon = JSON.parse(sessionStorage.getItem('lstDnAdqCon'))
      this.docNegociablesBaj = JSON.parse(sessionStorage.getItem('lstDnAdqBaj'))
    }

    aumentarArray1(){
      this.loading = true;
      let estado = "R";
      let numero = this.docNegociablesReg.length + 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesReg = resp     
        sessionStorage.setItem('lstDnAdqReg', JSON.stringify(this.docNegociablesReg))
        this.loading = false;
    
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontraron más documentos registrados',
          type: 'warning',
          heightAuto: false
        })
      })
    }

    aumentarArray2(){
      this.loading = true;
      let estado = "V";
      let numero = this.docNegociablesVer.length + 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesVer = resp     
        sessionStorage.setItem('lstDnAdqVer', JSON.stringify(this.docNegociablesVer))
        this.loading = false;
    
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontraron más documentos verificados',
          type: 'warning',
          heightAuto: false
        })
      })
    }

    aumentarArray3(){
      this.loading = true;
      let estado = "T";
      let numero = this.docNegociablesCot.length + 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesCot = resp     
        sessionStorage.setItem('lstDnAdqCot', JSON.stringify(this.docNegociablesCot))
        this.loading = false;
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontraron más documentos cotizados',
          type: 'warning',
          heightAuto: false
        })
      })
    }

    aumentarArray4(){
      this.loading = true;
      let estado = "C";
      let numero = this.docNegociablesCon.length + 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesCon = resp     
        sessionStorage.setItem('lstDnAdqCon', JSON.stringify(this.docNegociablesCon))
        this.loading = false;
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontraron más documentos con contrato',
          type: 'warning',
          heightAuto: false
        })
      })
    }

    aumentarArray5(){
      this.loading = true;
      let estado = "B";
      let numero = this.docNegociablesBaj.length + 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesBaj = resp     
        sessionStorage.setItem('lstDnAdqBaj', JSON.stringify(this.docNegociablesBaj))
        this.loading = false;
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontraron más documentos en baja',
          type: 'warning',
          heightAuto: false
        })
      })
    }

    ObtenerDnRegistrado(){
      this.loading = true;
      let estado = "R";
      let numero = 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesReg = resp
        this.ObtenerDnVerificado();
        this.docArray = this.docNegociablesReg.slice(0,10)      
        sessionStorage.setItem('lstDnAdqReg', JSON.stringify(this.docNegociablesReg))
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontro ningún documento registrado',
          type: 'warning',
          heightAuto: false
        })
      })
  
    }

    ObtenerDnVerificado(){
      this.loading = true;
      let estado = "V";
      let numero = 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesVer = resp
        this.ObtenerDnCotizado();
        sessionStorage.setItem('lstDnAdqVer', JSON.stringify(this.docNegociablesVer))
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontro ningún documento verificado',
          type: 'warning',
          heightAuto: false
        })
      })
    }

    ObtenerDnCotizado(){
      this.loading = true;
      let estado = "T";
      let numero = 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesCot = resp
        this.ObtenerDnContrato();
        sessionStorage.setItem('lstDnAdqCot', JSON.stringify(this.docNegociablesCot))
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontro ningún documento cotizado',
          type: 'warning',
          heightAuto: false
        })
      })
  
    }

    ObtenerDnContrato(){
      this.loading = true;
      let estado = "C";
      let numero = 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesCon = resp
        this.ObtenerDnBaja();
        sessionStorage.setItem('lstDnAdqCon', JSON.stringify(this.docNegociablesCon))
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontro ningún documento con contrato',
          type: 'warning',
          heightAuto: false
        })
      })
  
    }


    ObtenerDnBaja(){
      this.loading = true;
      let estado = "B";
      let numero = 10
      this.dashboardService.obtenerDnDashboard(this.DTOFiltrosDocNeg,estado,numero)
      .subscribe( resp => { 
        this.docNegociablesBaj = resp
        this.loading = false;
        sessionStorage.setItem('lstDnAdqBaj', JSON.stringify(this.docNegociablesBaj))
      },err => {
        Swal.fire({
          title:'Error',
          text: 'No se encontro ningún documento en baja',
          type: 'warning',
          heightAuto: false
        })
      })
    } 
  }

